import CryptoJS from "crypto-js"
import config from "../config/config"

const ROVER_COOKIE = "sfo-redd"
const aesSecret = config.cookiePart

let createCookie = (name,value,days) => {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 *1000));
        var expires = "; expires=" + date.toGMTString();
    }
    else {
        var expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

let readCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1,c.length);
        }
        if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length,c.length);
        }
    }
    return null;
}

let eraseCookie = (name) => {
    createCookie(name,"",-1);
}

let getRoverCookie = () => {
    var result = null;
    var c = readCookie(ROVER_COOKIE)
    if (c) {
        var bytes = CryptoJS.AES.decrypt(c, aesSecret)
        var plaintext = bytes.toString(CryptoJS.enc.Utf8)
        result = JSON.parse(plaintext);
    } else {
        result = {};
    }
    return result;
}

let setRoverCookie = (o) => {
    var s = JSON.stringify(o);
    var cipherText = CryptoJS.AES.encrypt(s, aesSecret);
    createCookie(ROVER_COOKIE, cipherText.toString());
}

let addCookie = (name, value) => {
    var o = getRoverCookie();
    o[name] = value;
    setRoverCookie(o);
}

let getCookie = (name) => {
    var o = getRoverCookie();
    return o[name];
}

let Cookies = {
    "keys": {
        "APIKEY": "ak",
        "EXPIRY": "ey",
        "QUERYPARAMS": "qp",
        "TOKEN": "tn"
    },
    "read": getCookie,
    "write": addCookie
}

export default Cookies;


// WEBPACK FOOTER //
// ./src/util/cookies.js